import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { CheckCircleIcon, ExclamationCircleIcon, InformationCircleIcon, XCircleIcon } from '@heroicons/react/24/solid';

const SnackbarAlert = ({ message, severity = 'info', duration = 4000 }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), duration);
    return () => clearTimeout(timer);
  }, [duration]);

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null;

  const severityStyles = {
    success: {
      bg: 'bg-green-100',
      border: 'border-green-500',
      text: 'text-green-700',
      icon: <CheckCircleIcon className="h-6 w-6 text-green-500" />,
    },
    info: {
      bg: 'bg-blue-100',
      border: 'border-blue-500',
      text: 'text-blue-700',
      icon: <InformationCircleIcon className="h-6 w-6 text-blue-500" />,
    },
    warning: {
      bg: 'bg-yellow-100',
      border: 'border-yellow-500',
      text: 'text-yellow-700',
      icon: <ExclamationCircleIcon className="h-6 w-6 text-yellow-500" />,
    },
    error: {
      bg: 'bg-red-100',
      border: 'border-red-500',
      text: 'text-red-700',
      icon: <XCircleIcon className="h-6 w-6 text-red-500" />,
    },
  };

  const { bg, border, text, icon } = severityStyles[severity];

  return (
    <div className={`fixed top-36 right-4 p-4 z-100 rounded-lg shadow-lg flex items-center space-x-2 border ${bg} ${border} ${text} animate-slide-in`}>
      {icon}
      <span className="flex-1">{message}</span>
      <button onClick={handleClose} className="text-xl font-bold hover:opacity-70">
        &times;
      </button>
    </div>
  );
};

// Helper function to render the SnackbarAlert
export const showSnackbar = (message, severity = 'info', duration = 4000) => {
  const snackbarRoot = document.getElementById('snackbar-root');
  const snackbarElement = document.createElement('div');
  snackbarRoot.appendChild(snackbarElement);

  const root = createRoot(snackbarElement);

  const removeSnackbar = () => {
    root.unmount();
    snackbarRoot.removeChild(snackbarElement);
  };

  root.render(<SnackbarAlert message={message} severity={severity} duration={duration} />);

  setTimeout(removeSnackbar, duration);
};

export default SnackbarAlert;


/**
 * showSnackbar('This is a warning message!', 'warning');
 * showSnackbar('This is a success message!', 'success');
 * showSnackbar('This is an error message!', 'error');
 * showSnackbar('This is an info message!', 'info');
 * 
 * duration in ms. 
 * 
 */